function About() {
  return (
    <div className="max-w-5xl mx-auto py-20 px-6">

      <h1 className="text-3xl font-bold mb-6">About RentEase</h1>

      <p className="text-gray-600 mb-4">
        RentEase is a modern rental platform that allows people to rent 
        furniture and appliances at affordable prices.
      </p>

      <p className="text-gray-600 mb-4">
        Our goal is to make urban living more flexible and affordable. 
        Instead of buying expensive furniture, customers can rent items 
        and upgrade whenever they want.
      </p>

      <p className="text-gray-600">
        We provide high quality products with fast delivery and reliable 
        support.
      </p>

    </div>
  );
}

export default About;
